import { create } from 'zustand';

type DrawerStoreProps = {
  isOpenDrawer: boolean;
  setIsOpenDrawer: (isOpen: boolean) => void;
};

const useDrawerStore = create<DrawerStoreProps>(set => ({
  isOpenDrawer: false,
  setIsOpenDrawer: isOpenDrawer => set({ isOpenDrawer })
}));

export default useDrawerStore;
